export default __webpack_public_path__ + "static/media/NotoSans-BoldItalic.18b4ab37.woff2";